import axios from "axios";

/** URL base de la API (env → VITE_API_URL; fallback → localhost) */
export const apiBaseUrl = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

/** Instancia *sin* interceptores, útil para peticiones que no deben autoinvocarse. */
export const base = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true, // envía la cookie `refresh`
});
